import { inject } from 'mobx-react';
import useLanguageChange from '../../../utils/hooks/useLanguageChange';
import Utils from '../../../utils/utils';

const MainInfo = ({ data, mainInfo, setMainInfo, showInvoiceNumber = true, hideInvoiceDate = false, forceDateEditable = false, onInvoiceDateChange }) => {
  useLanguageChange(data.t);
  const isDateEditable = forceDateEditable || Utils.hasExpenseField(data, 'field_invoice_date_editable', false);

  return (
    <div className='my-3'>
      <div className='d-flex'>
        <div className='d-flex flex-column flex-1'>
          {showInvoiceNumber && (
          <div className='d-flex pb-2'>
            <span className='report-label col-2'>{data.t.read('review_expense.invoice_number')} *</span>
            <div className='col-8'>
              <input className='form-control' type='text' name='invoice number' value={mainInfo.invoiceNumber} onChange={e => setMainInfo({ ...mainInfo, invoiceNumber: e.target.value })} data-testid='invoice-number-input' />
            </div>
          </div>
          )}
          {!hideInvoiceDate && <div className='d-flex pb-2'>
            <span className='report-label col-2'>{data.t.read('review_expense.invoice_date')} *</span>
            <div className='col-8'>
              <input className='form-control' type='date' name='current date' value={mainInfo.date ?? null} disabled={!isDateEditable} onChange={isDateEditable ? e => {
                setMainInfo({ ...mainInfo, date: e.target.value });
                onInvoiceDateChange?.(e.target.value);
              } : undefined} data-testid='invoice-date-input' />
            </div>
          </div>}
        </div>
      </div>
    </div>
  );
};

export default inject('data')(MainInfo);
